import React from 'react';
import { render, fireEvent } from '@testing-library/react';

import EventList from './EventList';

function makeEvent(id, message) {
  return {
    '@id': id,
    '@timestamp': '2026-03-28T14:30:00.000Z',
    Level: 'INFO',
    message: message || `Event ${id}`,
  };
}

describe('EventList', () => {
  it('renders visible events within the window', () => {
    const events = Array.from({ length: 5 }, (_, i) =>
      makeEvent(`evt-${i}`, `Message ${i}`),
    );

    const { getByText } = render(
      <EventList events={events} anchorId="evt-2" errorIds={[]} />,
    );

    // With only 5 events and WINDOW_SIZE=10, all should be visible
    events.forEach((evt) => {
      expect(getByText(evt.message)).toBeInTheDocument();
    });
  });

  it('shows "Show N earlier events" when there are hidden events before the window', () => {
    // Create 30 events with anchor near the end so earlier events are hidden
    const events = Array.from({ length: 30 }, (_, i) =>
      makeEvent(`evt-${i}`, `Message ${i}`),
    );

    const { getByText } = render(
      <EventList events={events} anchorId="evt-25" errorIds={[]} />,
    );

    // anchorIndex=25, initialStart=max(0,25-10)=15, so 15 hidden before
    expect(getByText(/Show 15 earlier events/)).toBeInTheDocument();
  });

  it('shows "Show N later events" when there are hidden events after the window', () => {
    // Create 30 events with anchor near the start so later events are hidden
    const events = Array.from({ length: 30 }, (_, i) =>
      makeEvent(`evt-${i}`, `Message ${i}`),
    );

    const { getByText } = render(
      <EventList events={events} anchorId="evt-3" errorIds={[]} />,
    );

    // anchorIndex=3, initialEnd=min(30,3+10+1)=14, so 30-14=16 hidden after
    expect(getByText(/Show 16 later events/)).toBeInTheDocument();
  });

  it('clicking expand buttons reveals hidden events', () => {
    const events = Array.from({ length: 30 }, (_, i) =>
      makeEvent(`evt-${i}`, `Message ${i}`),
    );

    const { getByText, queryByText } = render(
      <EventList events={events} anchorId="evt-25" errorIds={[]} />,
    );

    // Event 0 should be hidden initially (it is before the visible window)
    expect(queryByText('Message 0')).not.toBeInTheDocument();

    // Click to show earlier events
    fireEvent.click(getByText(/Show 15 earlier events/));

    // Now event 0 should be visible
    expect(getByText('Message 0')).toBeInTheDocument();
  });
});
